import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {},
  reducers: {
    chacheresults: (state, action) => {
      state = { ...action.payload, ...state };
    },
  },
});
export const { chacheresults } = searchSlice.actions;
export default searchSlice.reducer;
